import React, { useEffect, useState } from "react";
import RightIcon from "../Images/Arrow_right.svg";
import LeftIcon from "../Images/Arrow_left.svg";
import PosterOne from "./PosterOne";
import Image from "../Images/panner.png";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Autoplay, Pagination, Navigation } from "swiper/modules";
import { getBannerBasedOnCategory } from "../../../network/api/banner.js";
import { Link } from "react-router-dom";

function Poster({ id, sliderBanner }) {
  const [banner, setBanner] = useState([]);

  useEffect(() => {
    // getBannerBasedOnCategory(id).then((response) => {
    //   setBanner(response.data);
    // });
  }, [id]);

  return (
    <div className="panner">
      <Swiper
        spaceBetween={30}
        centeredSlides={true}
        autoplay={{
          delay: 2500,
          disableOnInteraction: false,
        }}
        pagination={{
          clickable: true,
        }}
        navigation={{
          prevEl: ".button-prev-slide",
          nextEl: ".button-next-slide",
        }}
        modules={[Autoplay, Pagination, Navigation]}
        className="mySwiper poster"
      >
        {/* <SwiperSlide>
          <img src={Image} />
        </SwiperSlide>
        <SwiperSlide>
          <img src={Image} />
        </SwiperSlide>
        <SwiperSlide>
          <img src={Image} />
        </SwiperSlide> */}
        {sliderBanner?.images?.map((item, index) => (
          <SwiperSlide key={index}>
            <Link to={item?.link}>
              <img
                src={item.secure_url}
                alt={`Banner ${index}`}
                style={{ width: "100%", height: "300px" }}
              />
            </Link>
          </SwiperSlide>
    
        ))}

        <div className="button-next-slide">
          <img src={RightIcon} alt="Right Arrow" />
        </div>
        <div className="button-prev-slide ">
          <img src={LeftIcon} alt="Left Arrow" />
        </div>
      </Swiper>
    </div>
  );
}

export default Poster;
